import GeneralDesc from '../models/GeneralDesc';
import { ApiState } from '../utils/requestAction';
import requestReducer from './requestReducer';

export interface GeneralDescState extends ApiState {
  generalDesc?: GeneralDesc[]
}

export default requestReducer<GeneralDescState>('GENERAL_DESC_LIST')